<div class="row g-3">
    <div class="col-sm-2 offset-sm-8">
        <ed-button
            [colorSchema]="buttonColors.Secondary"
            (click)="addBillingMilestone()"
            [disabled]="!project"
        >
            Ajouter des factures
        </ed-button>
    </div> <div class="col-sm-2">
        <ed-button
            [colorSchema]="buttonColors.Secondary"
            (click)="addBillingMilestoneRecurrence()"
            [disabled]="!project"
        >
            Ajouter une récurrence
        </ed-button>
    </div> 
</div>
<br/>
<div class="row g-3">
    <div class="col-sm-12">
        <ed-table
                title="Planning de facturation"
                [dataSource]="billingMilestoneData" 
                [displayedColumns]="billingMilestoneColumns"
                [sortInfo]="{field: 'plannedDate', order: -1}"
                [areActionsInElements]="true"
                (onDropdownMenuClick)="onActionClicked($event.object, $event.event)"
                (onRowClick)="updateBillingMilestone($event)"
                >
            </ed-table>
    </div>
</div>

